import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PropertyFinder } from '../../../shared/services/property-finder.service';
import { PropertyLinkService } from '../../../shared/services/property-link.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-property-item',
  templateUrl: './property-item.component.html',
  styleUrls: ['./property-item.component.scss'],
  providers: [],
})
export class PropertyItemComponent implements OnInit {
  @Input() item;
  @Output() isAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() redfinEst: EventEmitter<any> = new EventEmitter<any>();
  public redfinEstimateLoader;
  public redfinEstimate;
  public showRedfineEstimate;
  public searchLink;
  public chosenProperties = [];
  actionsMenuOpened = false;
  isClicked = false;
  // @Output() downloadEvent = new EventEmitter();
  // @Output() shareEmail = new EventEmitter();
  // @Input() leadId;
  // @Input() leadEmail;
  constructor(
    private PropertyFinderService: PropertyFinder,
    private propertyLink: PropertyLinkService,
  ) {
    this.redfinEstimateLoader = true;
    this.redfinEstimate = null;
    this.showRedfineEstimate = false;
  }

  ngOnInit() {
    this.isClicked = this.item.isClicked;
    if (!this.item.redfinEstimate) {
      this.PropertyFinderService.getRedfinEstimation(
        this.item.id,
        this.item.state,
      ).subscribe(
        res => {
          this.redfinEstimateLoader = false;
          this.showRedfineEstimate = true;
          this.redfinEstimate = res.estimate;
          this.redfinEst.emit(this.redfinEstimate);
        },
        err => {
          this.redfinEst.emit('N/A');
          this.redfinEstimateLoader = false;
          this.showRedfineEstimate = true;
        },
      );
    }
  }

  addProp(val, boolean) {
    var obj = {
      val: val,
      boolean: boolean,
    };
    this.isAdded.emit(obj);
  }

  openPropertyLink(event, property) {
    event.stopPropagation();
    var propertyLink = this.propertyLink.returnPropertyLink(
      property.neighborhood.name,
      property.city,
      property.state,
      property.id,
      property.address,
    );
    var propertyUrl = environment.urlDomain + '/' + propertyLink;
    window.open(propertyUrl, '_blank');
  }
}
